import React, { useEffect, useState } from 'react';
import {
    AiOutlinePlusCircle,
    AiOutlineDelete,
    AiOutlineEdit, AiOutlineCheck, AiOutlineClose
} from 'react-icons/ai';
import axios from 'axios';
import ToastNotification from '../../../components/ToastNotification';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { useLoading } from '../../../context/LoadingContext';


const AddHoliday = () => {

    const { setLoading } = useLoading();
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success',
    });

    const [confirmDialog, setConfirmDialog] = useState({
        show: false,
        title: '',
        message: '',
        onConfirm: null,
    });




    const [showForm, setShowForm] = useState(false);
    const [holidays, setHolidays] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);


    const [formData, setFormData] = useState({
        holiday_name: '',
        from_date: '',
        to_date: '',
        total_days: '',
        every_year: false,
        description: '',
    });


    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };
    const showConfirmDialog = ({ title, message, onConfirm }) => {
        setConfirmDialog({
            show: true,
            title,
            message,
            onConfirm: () => {
                onConfirm();
                setConfirmDialog({ ...confirmDialog, show: false });
            },
        });
    };



    const handleAddClick = () => {
        setShowForm(true);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let newFormData = {
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        };

  
        if ((name === 'from_date' || name === 'to_date') && newFormData.from_date && newFormData.to_date) {
            const fromDate = new Date(newFormData.from_date);
            const toDate = new Date(newFormData.to_date);

            if (toDate >= fromDate) {
                const diffTime = Math.abs(toDate - fromDate);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
                newFormData.total_days = diffDays;
            } else {
                newFormData.total_days = '';
            }
        }

        setFormData(newFormData);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.from_date) {
            showToast('From Date is required.', 'danger');
            return;
        }

        try {
            if (isEditing) {
                const res = await axios.put(`https://api.skyguard.group/api/update-holiday/${editingId}`, formData);

                setHolidays(prev =>
                    prev.map(itm => itm.id === editingId ? { id: editingId, ...formData } : itm)
                );
                showToast('Holiday updated successfully!', 'success');

            } else {
                const res = await axios.post('https://api.skyguard.group/api/add-holiday', formData);
                
                setHolidays(prev => [
                    { id: res.data.insertId, ...formData },
                    ...prev
                ]);
                showToast('Holiday added successfully!', 'success');
            }
            fetchHoliday();
            setFormData({
                holiday_name: '',
                from_date: '',
                to_date: '',
                total_days: '',
                every_year: false,
                description: '',
            });
            setIsEditing(false);
            setEditingId(null);
            setShowForm(false);
        } catch (error) {
            console.error('Error adding holidays', error);
            showToast('Failed to save holiday.', 'danger');
        }
    };

    const handleCancel = () => {
        setShowForm(false);
        setIsEditing(false);
        setEditingId(null);
        setFormData({
            holiday_name: '',
            from_date: '',
            to_date: '',
            total_days: '',
            every_year: false,
            description: '',
        });
    };

    const handleDelete = async (id) => {
        try {
            const res = await axios.delete(`https://api.skyguard.group/api/delete-holiday/${id}`);
            const updated = holidays.filter(h => h.id !== id);
            setHolidays(updated);
            fetchHoliday();
            showToast('Holiday deleted successfully!', 'success');

            if (isEditing && editingId === id) {
                setIsEditing(false);
                setEditingId(null);
                setShowForm(false);
                setFormData({
                    holiday_name: '',
                    from_date: '',
                    to_date: '',
                    total_days: '',
                    every_year: false,
                    description: '',
                });
            }
        } catch (error) {
            console.error("Error deleting holiday", error);
            showToast('Failed to delete holiday.', 'danger');
        }

    };


    const handleEdit = (id) => {
        const holidayToEdit = holidays.find(h => h.id === id);
        if (!holidayToEdit) return;

        setFormData({
            ...holidayToEdit,
            description: holidayToEdit.description || '',
        });

        setEditingId(id);
        setIsEditing(true);
        setShowForm(true);
    };

  

    const filteredData = (holidays || []).filter(itm =>
    Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
);



    const fetchHoliday = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-holiday');
            const sorted = Array.isArray(res.data.result)
                ? [...res.data.result].sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0))
                : res.data.result;
            setHolidays(sorted);

        } catch (error) {
            console.error("Error fetching holidays :", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchHoliday();
    }, [])


    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Holiday</h3>

                    {/* Search and Add */}
                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleAddClick}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button>
                        </div>
                    </div>

                    {/* Form Section */}
                    {showForm && (
                        <div className="card p-3 my-3 shadow-sm bg-white border">
                            <form onSubmit={handleSubmit}>
                                <div className="row">

 
                      {isEditing && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {formData.holiday_name}
    </span>
  </div>
)}                                   
                                    <div className="col-md-12">
                                        <div className="row g-3">
                                            {/* Holiday Name */}
                                            <div className="col-md-4">
                                                <label htmlFor="holiday_name" className="form-label fw-medium">
                                                    Holiday Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="holiday_name"
                                                    name="holiday_name"
                                                    value={formData.holiday_name}
                                                    onChange={handleChange}
                                                    placeholder="Enter Holiday Name"
                                                    required
                                                />
                                            </div>
                                            {/* From Date */}
                                            <div className="col-md-4">
                                                <label htmlFor="from_date" className="form-label fw-medium">
                                                    From Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="from_date"
                                                    name="from_date"
                                                    value={formData.from_date}
                                                    onChange={handleChange}
                                                    required
                                                    onInvalid={() => showToast('From Date is required.', 'danger')}
                                                />
                                            </div>
                                            {/* To Date */}
                                            <div className="col-md-4">
                                                <label htmlFor="to_date" className="form-label fw-medium">
                                                    To Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="to_date"
                                                    name="to_date"
                                                    value={formData.to_date}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className='row g-3 mt-1'>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">
                                                    Description
                                                </label>

                                                <textarea
                                                    className="form-control"
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleChange}
                                                    rows={3}
                                                />
                                            </div>
                                            {/* Total Days */}
                                            <div className="col-md-2">
                                                <label htmlFor="total_days" className="form-label fw-medium">
                                                    Total Days
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    id="total_days"
                                                    name="total_days"
                                                    value={formData.total_days}
                                                    onChange={handleChange}
                                                    readOnly
                                                />
                                            </div>

                                            {/* Every Year Checkbox */}
                                            <div className="col-md-4 ms-5">
                                                <label className="form-label fw-medium">Options</label>
                                                <div className="form-check mt-2">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="every_year"
                                                        name="every_year"
                                                        checked={formData.every_year}
                                                        onChange={handleChange}
                                                    />
                                                    <label
                                                        className="form-check-label fw-medium"
                                                        htmlFor="every_year"
                                                    >
                                                        Every Year
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Buttons */}
                                    <div className='d-flex justify-content-center mt-5 gap-2'>
                                        <button type='submit' className='btn btn-success'>
                                            {isEditing ? 'UPDATE' : 'SAVE'}
                                        </button>
                                        <button
                                            type='button'
                                            className='btn btn-danger'
                                            onClick={handleCancel}
                                        >
                                            CANCEL
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* Table Section */}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>SL</th>
                                        <th>Action</th>
                                    <th>Holiday Name</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Total Days</th>
                                    <th>Every Year</th>
                                
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((holiday, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                              <td>
                                                <button
                                                    className='btn btn-sm btn-primary mx-1'
                                                    onClick={() => handleEdit(holiday.id)}
                                                >
                                                    <AiOutlineEdit size={18} />
                                                </button>
                                                <button
                                                    className='btn btn-sm btn-danger mx-1'
                                                    // onClick={() => handleDelete(holiday.id)}
                                                    onClick={() =>
                                                        showConfirmDialog({
                                                            title: 'Delete Holiday',
                                                            message: `Are you sure you want to delete "${holiday.holiday_name}"?`,
                                                            onConfirm: () => handleDelete(holiday.id),
                                                        })
                                                    }
                                                >
                                                    <AiOutlineDelete size={18} />
                                                </button>
                                            </td>
                                            <td>{holiday.holiday_name}</td>
                                            <td>{holiday.from_date}</td>
                                            <td>{holiday.to_date}</td>
                                            <td>{holiday.total_days}</td>
                                            <td>{holiday.every_year ? <AiOutlineCheck color="green" size={18} /> : <AiOutlineClose color="red" size={20} />}</td>
                                          
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-danger fw-bold text-muted">No data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <ConfirmDialog
                show={confirmDialog.show}
                title={confirmDialog.title}
                message={confirmDialog.message}
                onConfirm={confirmDialog.onConfirm}
                onCancel={() => setConfirmDialog({ ...confirmDialog, show: false })}
            />


        </>
    );
};

export default AddHoliday;
